var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.form ? _c('vertical-table', _vm._b({
    attrs: {
      "items": _vm.computedItems
    }
  }, 'vertical-table', {
    itemsPerRow: _vm.itemsPerRow
  }, false), [_vm._l(_vm.computedItems, function (_ref) {
    var term = _ref.term,
      type = _ref.type,
      key = _ref.key,
      keys = _ref.keys,
      lastKey = _ref.lastKey,
      props = _ref.props,
      computedData = _ref.computedData;
    return [_vm.$slots[term] ? [_vm._t(term, null, {
      "slot": term
    })] : _vm.mode == 'view' ? [type == 'file-chips' ? [_c('v-file-chips', _vm._b({
      key: key,
      attrs: {
        "slot": term,
        "value": computedData,
        "mode": "view"
      },
      slot: term
    }, 'v-file-chips', props, false))] : _vm._e(), type == 'images-tile' ? [_c('v-images-tile-field', _vm._b({
      key: key,
      attrs: {
        "slot": term,
        "mode": "view"
      },
      slot: term,
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-images-tile-field', props, false))] : _vm._e()] : _vm.mode == 'form' ? [_c('div', {
      key: key,
      staticClass: "h-100",
      attrs: {
        "slot": term
      },
      slot: term
    }, [type == 'address' ? [_c('v-address-field', _vm._b({
      attrs: {
        "btnAttrs": {
          color: 'grey-6 white--text',
          className: 'w-80px w-lg-100px'
        }
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-address-field', props, false))] : _vm._e(), type == 'combobox' ? [_c('v-combobox', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-combobox', props, false))] : _vm._e(), type == 'currency' ? [_c('v-currency-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-currency-field', props, false))] : _vm._e(), type == 'date' ? [_c('v-date-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-date-field', props, false))] : _vm._e(), type == 'dates' ? [_c('v-row', {
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', [_c('v-date-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey]['startsAt'],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 'startsAt', $$v);
        },
        expression: "findData(keys)[lastKey]['startsAt']"
      }
    }, 'v-date-field', props, false))], 1), _c('v-col', {
      staticClass: "px-10",
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(" ~ ")]), _c('v-col', [_c('v-date-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey]['endsAt'],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 'endsAt', $$v);
        },
        expression: "findData(keys)[lastKey]['endsAt']"
      }
    }, 'v-date-field', props, false))], 1)], 1)] : _vm._e(), type == 'datetime' ? [_c('datetime-picker-field', _vm._b({
      attrs: {
        "label": "시작"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'datetime-picker-field', props, false))] : _vm._e(), type == 'datetimes' ? [_c('v-row', {
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', [_c('datetime-picker-field', _vm._b({
      attrs: {
        "type": "date",
        "label": "시작"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey]['startsAt'],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 'startsAt', $$v);
        },
        expression: "findData(keys)[lastKey]['startsAt']"
      }
    }, 'datetime-picker-field', props, false))], 1), _c('v-col', {
      staticClass: "px-10",
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(" ~ ")]), _c('v-col', [_c('datetime-picker-field', _vm._b({
      attrs: {
        "type": "date",
        "label": "종료"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey]['endsAt'],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 'endsAt', $$v);
        },
        expression: "findData(keys)[lastKey]['endsAt']"
      }
    }, 'datetime-picker-field', props, false))], 1)], 1)] : _vm._e(), type == 'duration' ? [_c('v-row', {
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', [_c('v-date-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey][0],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 0, $$v);
        },
        expression: "findData(keys)[lastKey][0]"
      }
    }, 'v-date-field', props, false))], 1), _c('v-col', {
      staticClass: "px-10",
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(" ~ ")]), _c('v-col', [_c('v-date-field', _vm._b({
      attrs: {
        "type": "date",
        "max": "2999-12-31"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey][1],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 1, $$v);
        },
        expression: "findData(keys)[lastKey][1]"
      }
    }, 'v-date-field', props, false))], 1)], 1)] : _vm._e(), type == 'editor' ? [_c('naver-smarteditor', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'naver-smarteditor', props, false))] : _vm._e(), type == 'email' ? [_c('v-email-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-email-field', props, false))] : _vm._e(), type == 'file' ? [_c('v-file-input', _vm._b({
      on: {
        "change": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-file-input', props, false))] : _vm._e(), type == 'file-chips' ? [_c('v-file-chips', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-file-chips', props, false))] : _vm._e(), type == 'hours' ? [_c('v-row', {
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', [_c('v-time-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey]['startsAt'],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 'startsAt', $$v);
        },
        expression: "findData(keys)[lastKey]['startsAt']"
      }
    }, 'v-time-field', props, false))], 1), _c('v-col', {
      staticClass: "px-10",
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(" ~ ")]), _c('v-col', [_c('v-time-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey]['endsAt'],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys)[lastKey], 'endsAt', $$v);
        },
        expression: "findData(keys)[lastKey]['endsAt']"
      }
    }, 'v-time-field', props, false))], 1)], 1)] : _vm._e(), type == 'images-tile' ? [_c('v-images-tile-field', _vm._b({
      on: {
        "change": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-images-tile-field', props, false))] : _vm._e(), type == 'password' ? [_c('v-password-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-password-field', props, false))] : _vm._e(), type == 'phone' ? [_c('v-phone-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-phone-field', props, false))] : _vm._e(), type == 'select' ? [_c('v-select', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-select', props, false))] : _vm._e(), type == 'switch' ? [_c('v-switch', _vm._b({
      staticClass: "pl-4",
      attrs: {
        "inset": "",
        "dense": "",
        "hide-details": ""
      },
      on: {
        "change": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-switch', props, false))] : _vm._e(), type == 'text' ? [_c('v-text-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-text-field', props, false))] : _vm._e(), type == 'textarea' ? [_c('v-textarea', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-textarea', props, false))] : _vm._e(), type == 'username' ? [_c('v-username-field', _vm._b({
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.findData(keys)[lastKey],
        callback: function ($$v) {
          _vm.$set(_vm.findData(keys), lastKey, $$v);
        },
        expression: "findData(keys)[lastKey]"
      }
    }, 'v-username-field', props, false))] : _vm._e(), props.coda ? [_c('p', {
      staticClass: "page-text--sm grey-6--text pl-8 pt-8 font-weight-regular",
      staticStyle: {
        "white-space": "pre-line"
      }
    }, [_vm._v(" " + _vm._s(props.coda) + " ")])] : _vm._e()], 2)] : _vm._e()];
  })], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }